import React, { useState } from 'react'

type SocialProps = {
  icon: React.ReactNode
  link: string
  color: string | null
}

const Social: React.FC<SocialProps> = ({ icon, link, color }) => {
  if (color && color.length === 7 && color[0] === '#') {
    const [isHover, setIsHover] = useState(false)

    const handleMouseEnter = () => {
      setIsHover(true)
    }
    const handleMouseLeave = () => {
      setIsHover(false)
    }

    const socialColor = color
    const style = {
      color: isHover ? socialColor : 'white',
      borderColor: socialColor,
      backgroundColor: isHover ? 'white' : socialColor,
    }

    return (
      <a
        href={link}
        target="_blank"
        className="{`bg-primary w-[30px] h-[30px] xl:w-[24px] xl:h-[24px]
        rounded-full flex flex-col items-center justify-center border-[1px] p-[3px]"
        rel="noopener noreferrer"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={style}
      >
        {icon}
      </a>
    )
  }

  return (
    <a
      href={link}
      target="_blank"
      className={`bg-primary w-[30px] h-[30px] xl:w-[24px] xl:h-[24px] 
        rounded-full flex flex-col items-center justify-center border-[1px] border-primary 
         hover:text-primary hover:bg-white transition-colors ease-in-out duration-300 p-[3px]`}
      rel="noopener noreferrer"
    >
      {icon}
    </a>
  )
}
export default Social
